import { useCreateProductServiceAdminAxiosInstance } from "../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import useSWR from "swr";

export function useKnownAnalyticsTags(item: "products" | "bundles") {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const url = `/${item}/analytics-tags/known-analytics-tags`;
  const { isLoading, data } = useSWR(url, async (url) => {
    const { data } = await createAxiosInstance().get<string[]>(url);
    return data;
  });

  return {
    analyticsTags: data ?? [],
    isLoading,
  };
}
